import { useTableActionContext } from '@aibees/elephant/context/table-action/context';
import { useBootstrapLabels } from '@aibees/elephant/hooks/bootstrap/use-bootstrap-labels';
import { useBrosweLabelsByIds } from '@aibees/elephant/hooks/labels/use-broswe-labels-by-ids';
import { SearchType } from '@aibees/elephant/types';
import { Label, LabelGrouping, LabelType } from '@aibees/elephant/types/label';
import { useMemo } from 'react';

export function useTableSelectionLabels(
  selectedIds: string[],
  labelType: LabelType,
  labelIds?: string[]
): [Label[], boolean] {
  // Use the flow's effective search type (folds in the ActionButton override) so
  // the record's currently-assigned lists/labels resolve against the right
  // grouping — e.g. a person opened from the employees sidebar on a company page,
  // whose People label ids would never match the company bootstrap set.
  const { effectiveSearchType } = useTableActionContext();
  const { items: bootstrapLabels } = useBootstrapLabels(
    labelType,
    effectiveSearchType === SearchType.People
      ? LabelGrouping.PEOPLE
      : LabelGrouping.COMPANY
  );

  const getLabelsByIdsApi = useBrosweLabelsByIds(
    { ids: selectedIds },
    selectedIds.length > 0
  );

  const labels = useMemo(() => {
    return bootstrapLabels.filter(
      (x) => getLabelsByIdsApi?.data?.includes(x.id) || labelIds?.includes(x.id)
    );
  }, [bootstrapLabels, getLabelsByIdsApi?.data, labelIds]);

  return useMemo(() => {
    return [labels, getLabelsByIdsApi?.isFetching ?? false];
  }, [getLabelsByIdsApi?.isFetching, labels]);
}
